import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue } from "bootstrap-vue";
import VeeValidate from "vee-validate";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import AsyncComputed from 'vue-async-computed'

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VeeValidate);
Vue.use(AsyncComputed);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
